import { render, staticRenderFns } from "./OrderItemDetail.vue?vue&type=template&id=0540ffe8&"
import script from "./OrderItemDetail.vue?vue&type=script&lang=js&"
export * from "./OrderItemDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports